import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import Util from '../../libs/util/Util';

/**
 * ヘッダー・ナビ管理
 */
export default class GlobalHeaderClass extends BaseClass {
  constructor() {
    super();
    this.name = 'GlobalHeaderClass';

    this.CL_FIXED = 'isFixed';
    this.CL_HIDE = 'isHide';

    this.CL_OPEN = 'isOpen';
    this.CL_NAV_READY = 'isNavReady';
    this.isOpen = false;

    this.onClickOpenListener = this.onClick_open.bind(this);
    this.onClickCloseListener = this.onClick_close.bind(this);

    this.prevScrollTop = -1;
    this.isShow = true;
    this.isFixed = false;

    this.headerHeight = 0;
    this.isFirstScroll = true;
  }

  onCreate() {
    super.onCreate();
    this.header = $('#g_header');
    this.nav = $('#g_nav');

    $('.g_wrap_logo .toggle a', this.header).on('click', this.onClickOpenListener);
    $('.g_wrap_logo .toggle a', this.nav).on('click', this.onClickCloseListener);

    $(document).on('click touchstart', (e) => {
      if (!$(e.target).closest('.g_wrap_logo .toggle,#g_nav').length && this.isOpen) {
        this.onClose();
      }
    });
  }

  onLoad() {
    super.onLoad();

    this.nav.addClass(this.CL_NAV_READY);
  }

  onResize() {
    super.onResize();

    this.headerHeight = this.header.outerHeight(true) / 2;
  }

  onScroll(_st) {
    super.onScroll(_st);
    if (!this.isImageLoadEnd || Util.isSpModalOpen) { return; }

    if (this.isFirstScroll) {
      this.isFirstScroll = false;
      this.isShow = true;
      this.header.removeClass(this.CL_HIDE);
    } else if (_st === this.prevScrollTop) {
      //
    } else if (_st > this.prevScrollTop && _st > this.headerHeight) {
      if (this.isShow) {
        this.isShow = false;
        this.header.addClass(this.CL_HIDE);
      }
    } else {
      if (!this.isShow) {
        this.isShow = true;
        this.header.removeClass(this.CL_HIDE);
      }
    }

    if (_st > 1) {
      if (!this.isFixed) {
        this.isFixed = true;
        this.header.addClass(this.CL_FIXED);
      }
    } else {
      if (this.isFixed) {
        this.isFixed = false;
        this.header.removeClass(this.CL_FIXED);
      }
    }

    this.prevScrollTop = _st;
  }

  onClick_open(e) {
    e.preventDefault();
    this.onOpen();
  }

  onClick_close(e) {
    e.preventDefault();
    this.onClose();
  }

  onOpen() {
    if (this.isOpen) { return; }
    this.isOpen = true;

    this.nav.addClass(this.CL_OPEN);
  }

  onClose() {
    if (!this.isOpen) { return; }
    this.isOpen = false;
    this.nav.removeClass(this.CL_OPEN);
  }
}
